import Portal from '@dc/ui-library/src/gadgets/Portal/';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import FiltersContainerDesktop from './FiltersContainerDesktop';
import FiltersContainerTabletMobile from './FiltersContainerTabletMobile';
import { touchDeviceType } from './filterHelpers';
import { filtersPropTypes } from './propTypes';
import * as UISettings from '../../../../../utils/UISettings';

class FiltersContainerMain extends PureComponent {
  render() {
    const { props } = this;
    const tariffSegmentLinkLabel =
      UISettings.get('component.listing-page-products.tariff-segment-link-label');
    const tariffSegmentLinkTarget =
      UISettings.get('component.listing-page-products.tariff-segment-link-target');
    const tariff = tariffSegmentLinkLabel && tariffSegmentLinkTarget && {
      label: tariffSegmentLinkLabel,
      target: tariffSegmentLinkTarget
    };

    const splitLabel = props.categoryProductCount === 1
      ? `${props.categoryProductCount} result`
      : `${props.categoryProductCount} results`;

    if (touchDeviceType(props.deviceType)) {
      return (
        <Portal domNode={document.body}>
          <FiltersContainerTabletMobile
            filters={props.filters}
            label={splitLabel}
            deviceType={props.deviceType}
            tariff={tariff}
          />
        </Portal>
      );
    }

    return (
      <FiltersContainerDesktop
        filters={props.filters}
        deviceType={props.deviceType}
        tariff={tariff}
      />
    );
  }
}

FiltersContainerMain.propTypes = {
  deviceType: PropTypes.oneOf(['wide', 'desktop', 'tablet', 'mobile']).isRequired,
  categoryProductCount: PropTypes.number.isRequired,
  filters: filtersPropTypes.isRequired
};

FiltersContainerMain.displayName = 'FiltersContainerMain';

function mapStateToProps(state) {
  return {
    categoryProductCount: state.listingPage.pagination.itemsNumberPerPage.categoryProductCount
  };
}

export default connect(mapStateToProps)(FiltersContainerMain);
